import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Çift scroll düzeltmesi (mobil için garanti çözüm)
    window.scrollTo(0, 0); // Anında
    //Bu iki satır sonradan eklendi.
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    setTimeout(() => {
      window.scrollTo(0, 0); // Route değişiminden hemen sonra tekrar
    }, 150); // Gerekirse 300'e çıkabilir.
  }, [pathname]);

  return null;
}

// import { useEffect } from "react";
// import { useLayoutEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollToTop = () => {
//     const {pathname } = useLocation();

//     useEffect(() => {
//        //Sayfa her değiştiğinde yukarı kaydırma işlemi
//        window.scrollTo(0,0);
//        document.body.scrollTop = 0;
//        document.documentElement.scrollTop = 0;
//     }, [pathname]);

//     return null;
// };

// export default ScrollToTop;